var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  padding-left: 16px;\n  padding-right: 16px;\n  &.shadow {\n    box-shadow:\n      0 2.8px 2.2px rgba(0, 0, 0, 0.02),\n      0 6.7px 5.3px rgba(0, 0, 0, 0.028),\n      0 12.5px 10px rgba(0, 0, 0, 0.035),\n      0 22.3px 17.9px rgba(0, 0, 0, 0.042),\n      0 41.8px 33.4px rgba(0, 0, 0, 0.05),\n      0 100px 80px rgba(0, 0, 0, 0.07)\n    ;\n  }\n'], ['\n  text-align: center;\n  padding-left: 16px;\n  padding-right: 16px;\n  &.shadow {\n    box-shadow:\n      0 2.8px 2.2px rgba(0, 0, 0, 0.02),\n      0 6.7px 5.3px rgba(0, 0, 0, 0.028),\n      0 12.5px 10px rgba(0, 0, 0, 0.035),\n      0 22.3px 17.9px rgba(0, 0, 0, 0.042),\n      0 41.8px 33.4px rgba(0, 0, 0, 0.05),\n      0 100px 80px rgba(0, 0, 0, 0.07)\n    ;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject);

var QQIntro = function QQIntro(props) {
  var withShadow = props.withShadow;
  var cn = withShadow ? 'shadow' : '';
  return React.createElement(Container, {
    className: cn
  }, React.createElement('h2', null, props.children));
};

export default QQIntro;